"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typesafe_actions_1 = require("typesafe-actions");
var SfilterSizeAction;
(function (SfilterSizeAction) {
    SfilterSizeAction.ON_TOGGLE_SIZE_SECTION = 'ON_TOGGLE_SIZE_SECTION';
    SfilterSizeAction.TOGGLE_SIZE_SECTION = 'TOGGLE_SIZE_SECTION';
    SfilterSizeAction.SHOW_CUSTOM_SIZE = 'SHOW_CUSTOM_SIZE';
    SfilterSizeAction.ON_SELECT_SIZE_RANGE = 'ON_SELECT_SIZE_RANGE';
    SfilterSizeAction.CHANGE_SIZE_RANGE = 'CHANGE_SIZE_RANGE';
    SfilterSizeAction.CHANGE_CUSTOM_SIZE = 'CHANGE_CUSTOM_SIZE';
    SfilterSizeAction.ON_CUSTOM_SIZE_CHANGED = 'ON_CUSTOM_SIZE_CHANGED';
    SfilterSizeAction.SET_CUSTOM_SIZE = 'SET_CUSTOM_SIZE';
    SfilterSizeAction.ON_CHANGE_SIZE_TYPE = 'ON_CHANGE_SIZE_TYPE';
    SfilterSizeAction.CHANGE_SIZE_TYPE = 'CHANGE_SIZE_TYPE';
    SfilterSizeAction.toggleSizeSection = typesafe_actions_1.createAction(SfilterSizeAction.TOGGLE_SIZE_SECTION, function (resolve) { return function (state) { return resolve(state); }; });
    SfilterSizeAction.onToggleSizeSection = typesafe_actions_1.createAction(SfilterSizeAction.ON_TOGGLE_SIZE_SECTION, function (resolve) { return function () { return resolve(); }; });
    SfilterSizeAction.showCustomSize = typesafe_actions_1.createAction(SfilterSizeAction.SHOW_CUSTOM_SIZE, function (resolve) { return function () { return resolve(); }; });
    SfilterSizeAction.changeCustomSize = typesafe_actions_1.createAction(SfilterSizeAction.CHANGE_CUSTOM_SIZE, function (resolve) { return function (state) { return resolve(state); }; });
    SfilterSizeAction.onSelectSizeRange = typesafe_actions_1.createAction(SfilterSizeAction.ON_SELECT_SIZE_RANGE, function (resolve) {
        return function (index, from, to) { return resolve({ index: index, from: from, to: to }); };
    });
    SfilterSizeAction.changeSizeRange = typesafe_actions_1.createAction(SfilterSizeAction.CHANGE_SIZE_RANGE, function (resolve) { return function (from, to) { return resolve({ from: from, to: to }); }; });
    SfilterSizeAction.onCustomSizeChanged = typesafe_actions_1.createAction(SfilterSizeAction.ON_CUSTOM_SIZE_CHANGED, function (resolve) {
        return function (from, to, fromIndex, toIndex) {
            return resolve({ from: from, to: to, fromIndex: fromIndex, toIndex: toIndex });
        };
    });
    SfilterSizeAction.setCustomSize = typesafe_actions_1.createAction(SfilterSizeAction.SET_CUSTOM_SIZE, function (resolve) {
        return function (from, to) {
            return resolve({ from: from, to: to });
        };
    });
    SfilterSizeAction.onChangeSizeType = typesafe_actions_1.createAction(SfilterSizeAction.ON_CHANGE_SIZE_TYPE, function (resolve) { return function (type) { return resolve(type); }; });
    SfilterSizeAction.changeSizeType = typesafe_actions_1.createAction(SfilterSizeAction.CHANGE_SIZE_TYPE, function (resolve) { return function (type) { return resolve(type); }; });
})(SfilterSizeAction || (SfilterSizeAction = {}));
exports.default = SfilterSizeAction;
